<template>
  <footer
    id="main_footer"
    class="text-small"
  >
    <nav class="flex-vcenter">
      <div class="content">
        <!-- @slot Emplacement pour des liens dans la partie gauche du footer. -->
        <slot name="left-links" />
      </div>
      <div class="content">
        <!-- @slot Emplacement pour des liens dans la partie droite du footer. -->
        <slot name="right-links" />
        <span id="copyright">© {{ currentYear }} LDE</span>
      </div>
    </nav>
  </footer>
</template>

<script>
import { defineComponent } from "vue";
/**
 * Affiche le footer du site.
 */
export default defineComponent({
  name: "MainFooter",
  computed: {
    /**
     * Retourne l'année en cours.
     * @returns {number} L'année en cours.
     */
    currentYear() {
      return new Date().getFullYear();
    },
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/_variables.scss" as var;

#main_footer {
  padding: var.$space-tiny;
  background-color: var.$blue-light;
  nav { justify-content: space-between; }

  .content > * {
    display: inline-block;
    color: var.$white;
    &:not(:last-child) { margin-right: var.$space-tiny; }
    &:not(#copyright) { text-decoration: underline; }
  }

  .button {
    padding: 0;
    border: none;
  }
}
</style>
